import { c as _c } from "react/compiler-runtime";
import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { IconCircleX } from "central-icons/IconCircleX";
import type { ComponentProps } from "react";
import DemoPanel from "@/components/preview/demo-panel";
import DemoSplit from "@/components/preview/demo-split";
import DemoWrapper, { NestedDemo } from "@/components/preview/demo-wrapper";
import { IconBadge } from "@/components/ui/icon-badge";
import { cn } from "@/lib/utils";
type FontSmoothingDemoProps = Pick<ComponentProps<typeof DemoWrapper>, "captionText" | "className" | "height" | "margin"> & {
  nested?: boolean;
  panelClassName?: string;
};
export default function FontSmoothingDemo(t0) {
  const $ = _c(23);
  let nested;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      nested,
      panelClassName: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = nested;
    $[2] = props;
    $[3] = t1;
  } else {
    nested = $[1];
    props = $[2];
    t1 = $[3];
  }
  const panelClassName = t1 === undefined ? "p-10" : t1;
  const Wrapper = nested ? NestedDemo : DemoWrapper;
  let t2;
  if ($[4] !== panelClassName) {
    t2 = cn("flex-col items-start gap-4", panelClassName);
    $[4] = panelClassName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex w-full select-none flex-col gap-0.5 antialiased" style={{
      MozOsxFontSmoothing: "auto",
      WebkitFontSmoothing: "auto"
    }}><p className="font-medium text-gray-1200 text-xl">Subpixel rendering</p><p className="text-pretty text-gray-1100">Default font smoothing uses subpixel antialiasing on macOS.</p></div>;
    t4 = <IconBadge color="gray" icon={IconCircleX} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2) {
    t5 = <DemoPanel innerClassName={t2}>{t3}{t4}</DemoPanel>;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== panelClassName) {
    t6 = cn("flex-col items-start gap-4", panelClassName);
    $[10] = panelClassName;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex w-full select-none flex-col gap-0.5 antialiased"><p className="font-medium text-gray-1200 text-xl">Antialiased rendering</p><p className="text-pretty text-gray-1100">Grayscale antialiasing produces thinner, crisper light text.</p></div>;
    t8 = <IconBadge color="sky" icon={IconCircleCheck} />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6) {
    t9 = <DemoPanel innerClassName={t6}>{t7}{t8}</DemoPanel>;
    $[14] = t6;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t9) {
    t10 = <DemoSplit className="h-full" stackBelow="sm">{t5}{t9}</DemoSplit>;
    $[16] = t5;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== Wrapper || $[20] !== props || $[21] !== t10) {
    t11 = <Wrapper {...props}>{t10}</Wrapper>;
    $[19] = Wrapper;
    $[20] = props;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}